import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty } from 'lodash';
import HomeAction from '../actions/HomeAction';
import AddressSearchMessages from '../../components/AddressSearch/AddressSearchMessages/AddressSearchMessages';
import { HomeSelector } from '../reducers/HomeReducer';
import { PlansSelector } from '../reducers/PlansReducer';

const mapStateToProps = state => ({
  address: HomeSelector.getFullAddress(state),
  isAddressSelected: HomeSelector.getIsAddressSelected(state),
  isUnavailable: isEmpty(PlansSelector.getAvailablePlans(state)),
  hasError: !isEmpty(HomeSelector.getError(state)),
  isUfbReady: PlansSelector.getUfbReady(state),
  isUfbAvailable: PlansSelector.getUfbAvailable(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetAddressSearch: HomeAction.resetAddressSearch
    },
    dispatch
  );

/* ToDo: cleaner the form state on resetAddressSearch */

const AddressSearchMessagesContainer = connect(mapStateToProps, mapDispatchToProps)(AddressSearchMessages);

export default AddressSearchMessagesContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/AddressSearchMessagesContainer.js
 **/